class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();

      const formData = new FormData(this.form);

      const allowedKeys = ["id", "quantity"];
      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        const property = /properties\[(?<propertyKey>.+)\]/gm.exec(name);

        if (property || allowedKeys.includes(name)) {
          if (!property) {
            data[name] = value;
          } else {
            if (!("properties" in data)) {
              data.properties = {};
            }
            data.properties[property.groups.propertyKey] = value;
          }
        }
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      data.quantity = parseInt(data.quantity);

      window.addToCart(data, {
        onError: (response) => {
          if (response?.errors) {
            document.dispatchEvent(
              new CustomEvent("cart:errors", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description || "",
                  message: response?.message,
                },
              }),
            );
          }

          this.showError(response);
        },
        onAfterAdd: () => {
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        },
      });
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }

  showError(response) {
    // Error handling for gift cards is done in gift-card-recipient-form.
    const giftCardRecipientKeys = ["email", "name", "message", "send_on"];

    if (response?.errors) {
      Object.keys(response.errors).some((key) =>
        giftCardRecipientKeys.includes(key),
      );
      return;
    }

    const message =
      response?.message || window.localeStrings.product.add_to_cart_error;
    const error = document.createElement("div");
    error.classList.add("add-to-cart-error");
    error.innerHTML = message;

    this.form.append(error);

    setTimeout(() => {
      error.remove();
    }, 3000);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
